import React from 'react';

import './styles.scss';

const UserNotFound = () => {
  return (
    <div className="user-not-found-container">
      <span className="not-found">User not found !</span>
      <h4>Please contact admin!</h4>
    </div>
  );
};

export default UserNotFound;
